import { Modal, PrimaryButton, PrimaryCardButton, TextArea } from '@cb/apricot-react';
import { Grid } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import { useToasts } from 'src/hooks';
import { useAuth } from 'src/contexts';
import { noteAdd } from '../../../services/schoolRequest';
import { ISummary } from 'src/types';
import { CircularProgress } from '@mui/material';

interface AddVettingNotesModalProps {
  isOpen?: boolean;
  request: ISummary | null;
  onClose: VoidFunction;
  onComplete: (request: ISummary) => void;
}

const AddVettingNotesModal: FC<AddVettingNotesModalProps> = ({ isOpen, request, onClose, onComplete }) => {
  const { userName } = useAuth();
  const [loading, setLoading] = useState('');
  const [adminVettingNotes, setAdminVettingNotes] = useState('');

  const { render: renderToasts, toastErrorMessage } = useToasts();

  const handleChangeAdminVettingNotes = (event: any) => {
    setAdminVettingNotes(event.target.value);
  };

  const handleSubmit = async () => {
    if (!adminVettingNotes || !request) {
      toastErrorMessage('Incomplete data -- please fill internal vetting notes');
    } else {
      setLoading('Saving');
      toastErrorMessage(null);

      try {
        const updated = await noteAdd(request.userId, request.categoryId, {
          user: userName,
          message: adminVettingNotes
        });
        request.updateDate = updated.time;
        onComplete(request);
      } catch (error: any) {
        toastErrorMessage(error.message);
      }
      setLoading('');
    }
  };

  useEffect(() => {
    setAdminVettingNotes('');
  }, [isOpen]);

  return (
    // @ts-ignore
    <Modal
      title="Enter Internal Vetting Notes"
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit} disabled={loading ? true : false}>
          Confirm
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose} disabled={loading ? true : false}>
          Close
        </PrimaryCardButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>

      {renderToasts()}

      <Grid container spacing={2} >
        <Grid item xs={12}>
          <TextArea onChange={handleChangeAdminVettingNotes} value={adminVettingNotes} maxLength={5000} />
        </Grid>
      </Grid>

      {loading &&
        <div style={{ marginTop: '20px' }}>
          <Grid item xs={12}><CircularProgress /> <div style={{ display: 'inline-block', fontSize: '20px' }}>{loading}</div></Grid>
        </div>
      }
    </Modal>
  );
};

export default AddVettingNotesModal;
